<script lang="ts">
  import { fade } from "svelte/transition";
  import { linkTransactionsModal } from "../../../stores/link-transactions-modal-store";
  import TextNew from "../../TextNew.svelte";

  export let title: string;

  $: linkingModuleVisible = $linkTransactionsModal.showLinkingModule;
</script>

<div class="container">
  {#key linkingModuleVisible}
    <div in:fade|global={{ duration: 200 }}>
      {#if linkingModuleVisible}
        <TextNew size="s" --rk-text-color="var(--rekki-transparency-dark)">
          select relevant documents from the list</TextNew
        >
      {:else}
        <TextNew size="s" --rk-text-color="var(--rekki-transparency-dark)">
          {title}</TextNew
        >
      {/if}
    </div>
  {/key}
</div>

<style>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    background-color: var(--rk-neutral-0);
    border: solid 1px var(--rk-divider-0);
    border-radius: 8px;
    text-align: center;
  }
</style>
